import { comp } from "../func/comp";
import { $iter } from "../iterator";
import { drop } from "./drop";
import { take } from "./take";
export function page(...args) {
    return ($iter(page, args) ||
        comp(drop(args[0] * (args[1] || 10)), take(args[1] || 10)));
}
